import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';

import {MenubarModule} from 'primeng/menubar';
import {ToolbarModule} from 'primeng/toolbar';
import {ButtonModule} from 'primeng/button';
import {MenuModule} from 'primeng/menu';
import {RouterLink} from '@angular/router';
import {BadgeModule} from 'primeng/badge';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from 'primeng/api';
import {MatIconModule} from '@angular/material/icon';
import {TooltipModule} from 'primeng/tooltip';

@Component({
  selector: 'app-header-text-icon',
  templateUrl: './header-text-icon.component.html',
  styleUrls: ['./header-text-icon.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MenubarModule,
    ToolbarModule,
    ButtonModule,
    MenuModule,
    RouterLink,
    BadgeModule,
    TranslateModule,
    SharedModule,
    MatIconModule,
    TooltipModule
],
})
export class HeaderTextIconComponent {
  @Output() toggleChange = new EventEmitter<boolean>(true);

  public readonly VERSION = environment.VERSION;

  public toggled = true;

  toggleSideNav() {
    this.toggled = !this.toggled;
    this.toggleChange.emit(this.toggled);
  }
}
